import { DataFetchWrapper } from "@tfg/ui"

import { useFindIngestionSettings } from "~/gen/api"
import { IngestionClientSettings } from "~/pages/Brand/OrganizationSettings/IngestionSettings/IngestionClientSettings.tsx"

export function IngestionClientSettingsLayout() {
  const findIngestionSettings = useFindIngestionSettings()

  return (
    <DataFetchWrapper query={findIngestionSettings}>
      {({ data }) => <IngestionClientSettings data={data.data} />}
    </DataFetchWrapper>
  )
}
